import { Box, Text, Timer } from '@betty/moonlight';
import { memo, useMemo } from 'react';
import { Trans, useTranslation } from '@betty/i18n';
import { AdditionalInfoProps } from './AdditionalInfo.types';
import { useSelector } from '@betty/toolkit/state';
import { selectFilteredLimitsByType } from '../../state';

function AdditionalText({ field, labelSymbol, type }: AdditionalInfoProps) {
  const { t } = useTranslation('responsibleGaming');
  const limits = useSelector(selectFilteredLimitsByType(type));

  const fieldData = limits?.find((item) => item.period === field);

  const transValues = useMemo(
    () => ({
      amount: `${labelSymbol ? '' : '$'}${fieldData?.pendingAmount?.toLocaleString('en-US')} ${labelSymbol ? t('hours') : ''}`,
    }),
    [fieldData?.pendingAmount, labelSymbol, t],
  );

  const transComponents = useMemo(
    () => ({
      time: (
        <Timer
          color="darkSurfaceMuted"
          variant="caption-semi"
          time={fieldData?.activeFrom ?? ''}
        />
      ),
    }),
    [fieldData?.activeFrom],
  );

  if (!fieldData?.activeFrom) return null;

  const textVariant = fieldData?.pendingAmount
    ? 'additionalTextStart'
    : 'additionalTextRemove';

  return (
    <Box flexDirection="row">
      <Text
        variant="caption"
        locNS="responsibleGaming"
        locKey={textVariant}
        color="darkSurfaceMuted"
        textAlign="center"
      >
        <Trans
          ns="responsibleGaming"
          i18nKey={textVariant}
          components={transComponents}
          values={transValues}
        />
      </Text>
    </Box>
  );
}

export default memo(AdditionalText);
